import {HELPERS_DEFER} from '../../constants';
import {schedule, types} from '../../scheduler';
const {DEFER_HELPER_EXECUTION} = types;

// the origin event handler for an action is ran as a microtask because it has to wait to see if
// preventDefault has been called by an ancestor. because of this back-to-back dispatches
// triggered from a user event such as a click can cause stale state or properties in helper
// callbacks (or just event handlers) in the view. so far this is only replicable programmtically
// doing something like btn.click(); btn.click(); where these clicks dispatch an action that then updates
// state or properties in an effect hander and the dispatch callback in the view relies on state
// or properties. eventually this use case needs to be accounted for in the scheduler design.
export default function deferHelperExecution(executionTiming, fn, meta) {
	return executionTiming === HELPERS_DEFER
		? schedule({fn, type: DEFER_HELPER_EXECUTION, meta})
		: fn();
}
